import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const getSpecialistRating = async (teamId: string | undefined) => {
  if (!teamId) return { average: 0, count: 0 };

  const { data, error } = await supabase
    .from('reviews')
    .select('team_rank')
    .eq('team_id', teamId)
    .not('team_rank', 'is', null);

  if (error) {
    throw new Error(error.message);
  }

  if (data && data.length > 0) {
    const total = data.reduce((sum, review) => sum + (review.team_rank || 0), 0);
    const average = (total / data.length).toFixed(1);
    return {
      average: parseFloat(average),
      count: data.length,
    };
  }

  return { average: 0, count: 0 };
};

export default function useGetSpecialistRating(teamId: string | undefined) {
  return useQuery({
    queryKey: ['specialistRating', teamId],
    queryFn: () => getSpecialistRating(teamId),
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: !!teamId,
  });
}
